import { Box, Button, SxProps, Theme } from '@mui/material';
import { API_AUTH_URL } from 'api';

// Логотип «Я» в фирменном красном круге Яндекса — не зависит от внешних icon-наборов.
const yandexLogo = (
  <Box
    component="span"
    aria-hidden
    sx={{ height: 24, display: 'flex', alignItems: 'center' }}
  >
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><script/><path d="M2.04 12c0-5.523 4.476-10 10-10 5.522 0 10 4.477 10 10s-4.478 10-10 10c-5.524 0-10-4.477-10-10z" fill="#FC3F1D"/><path d="M13.32 7.666h-.924c-1.694 0-2.585.858-2.585 2.123 0 1.43.616 2.1 1.881 2.959l1.045.704-3.003 4.487H7.49l2.695-4.014c-1.55-1.111-2.42-2.19-2.42-4.015 0-2.288 1.595-3.85 4.62-3.85h3.003v11.868H13.32V7.666z" fill="#fff"/><script/></svg>
  </Box>
);

type YandexLoginButtonProps = {
  label?: string;
  sx?: SxProps<Theme>;
  disabled?: boolean
};

/**
 * Кнопка входа через Яндекс.
 *
 * ВАЖНО: это серверный (redirect-based) OAuth-флоу. Переход выполняется полной
 * навигацией браузера (`window.location.href`), а НЕ через fetch/axios — на пути
 * есть кросс-доменные редиректы на oauth.yandex.ru и обратно, которые XHR/CORS
 * не отрабатывает.
 */
export default function YandexLoginButton({
  label = 'Войти через Яндекс',
  sx,
  disabled = false
}: YandexLoginButtonProps) {
  const handleClick = () => {
    // Нормализуем слэш: REACT_APP_API_AUTH_URL заканчивается на "/"
    const base = API_AUTH_URL.replace(/\/+$/, '');
    window.location.href = `${base}/auth/yandex`;
  };

  return (
    <Button
      type="button"
      fullWidth
      variant="outlined"
      size="large"
      startIcon={yandexLogo}
      disabled={disabled}
      onClick={handleClick}
      sx={{ textTransform: 'none', ...sx }}
    >
      {label}
    </Button>
  );
}
